var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',_vm._b({attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M3 13.001l6.794 6.68L21.65 3.666"}},'path',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }